<template>
    <div
        class="vehicle-selection container p-4 mb-4"
        v-if="rides && rides.length > 0"
    >
        <div class="section-form mb-5">
            <div class="section-header">
                <h5 class="text-center text-white">
                    <i class="fa fa-car mr-2"></i>
                    Caronas Disponíveis
                </h5>
                <p class="text-center text-white">
                    Você pode solicitar carona em uma das reservas abaixo ao invés de criar uma nova reserva
                </p>
            </div>

            <div class="rides-list">
                <div
                    v-for="ride in displayedRides"
                    :key="ride.id"
                    class="ride-card"
                    :class="{ 'selected': selectedRide && selectedRide.id === ride.id }"
                >
                    <div class="ride-info">
                        <div class="ride-header">
                            <div class="ride-owner">
                                <i class="fa fa-user mr-2"></i>
                                <strong>{{ ride.user ? ride.user.name : 'Usuário' }}</strong>
                            </div>
                        </div>

                        <div class="ride-details">
                            <div class="detail-item">
                                <i class="fa fa-calendar mr-1"></i>
                                <span>Retirada: {{ ride.retreat_date }}</span>
                            </div>
                            <div class="detail-item">
                                <i class="fa fa-calendar-check mr-1"></i>
                                <span>Devolução: {{ ride.devolution_date }}</span>
                            </div>
                            <div
                                class="detail-item"
                                v-if="ride.vehicles"
                            >
                                <i class="fa fa-users mr-1"></i>
                                <span>
                                    Lugares disponíveis: {{ getAvailableSeats(ride) }}
                                </span>
                            </div>
                        </div>

                        <div
                            class="ride-driver"
                            v-if="ride.driver"
                        >
                            <i class="fa fa-id-card mr-1"></i>
                            <span>Motorista: {{ ride.driver.name }}</span>
                        </div>
                    </div>

                    <div class="ride-actions">
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="selectRide(ride)"
                        >
                            <i class="fa fa-hand-paper-o mr-1"></i>
                            Pedir Carona
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="text-center mt-3"
                v-if="!showAll && rides.length > 3"
            >
                <button
                    type="button"
                    class="btn btn-link"
                    @click="showAll = true"
                >
                    Ver todas as caronas disponíveis ({{ rides.length }})
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AvailableRides',
    props: {
        rides: {
            type: Array,
            default: () => []
        },
        selectedRide: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            showAll: false
        };
    },
    computed: {
        displayedRides() {
            if (this.showAll) {
                return this.rides;
            }
            return this.rides.slice(0, 3);
        }
    },
    methods: {
        getAvailableSeats(ride) {
            if (!ride.vehicles) return 0;

            const totalSeats = ride.vehicles.places || 0;
            const occupiedSeats = ride.is_driver ? 1 : 2; // Se não é motorista, ocupa 2 lugares
            const passengers = ride.ride_count;

            return Math.max(0, totalSeats - occupiedSeats - passengers);
        },

        selectRide(ride) {
            this.$emit('select-ride', ride);
        }
    }
};
</script>

<style scoped>
.vehicle-selection {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.section-header {
    margin: -1.3rem;
    margin-bottom: 15px;
}

.rides-list {
    display: grid;
    gap: 15px;
}

.ride-card {
    background: white;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
}

.ride-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.ride-card.selected {
    border-color: #28a745;
    border-width: 3px;
    background-color: #f0fff4;
    box-shadow: 0 0 10px rgba(40, 167, 69, 0.2);
}

.ride-info {
    flex: 1;
}

.ride-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.ride-owner {
    font-size: 1.1rem;
    color: #333;
}

.ride-details {
    display: flex;
    gap: 20px;
    margin: 10px 0;
    flex-wrap: wrap;
}

.detail-item {
    font-size: 0.9rem;
    color: #666;
    display: flex;
    align-items: center;
}

.ride-driver {
    margin-top: 10px;
    font-size: 0.9rem;
    color: #666;
}

.ride-actions {
    display: flex;
    align-items: center;
}

.btn-primary {
    background-color: #FE8D18;
    border-color: #FE8D18;
}

.btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
    padding: 5px 10px;
    font-size: 0.85rem;
}

@media (max-width: 768px) {
    .ride-card {
        flex-direction: column;
        align-items: flex-start;
    }

    .ride-actions {
        width: 100%;
        margin-top: 15px;
    }

    .ride-actions button {
        width: 100%;
    }

    .ride-details {
        flex-direction: column;
        gap: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/add-components/AvailableRides.vue